module.exports = __webpack_public_path__ + "media/hospital.bdcf9da6.mp3";